import { Tag, Typography } from 'antd';
import { FC } from 'react';

import { BRAND_COLORS } from '../../../../../../constants/styles';
import { MetricsDivider } from '../MetricsDivider';
import { SectionLabel } from '../SectionLabel';

const { Text } = Typography;

const fmtDateTime = (d: Date) =>
  d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

export const MetricPeriodSection: FC<{
  sectionLabel: string;
  periodStart: Date;
  periodEnd: Date;
  headerValue: string;
  headerPeriodLabel: string;
  statusColor: string;
  statusLabel: string;
  children: React.ReactNode;
}> = ({
  sectionLabel,
  periodStart,
  periodEnd,
  headerValue,
  headerPeriodLabel,
  statusColor,
  statusLabel,
  children,
}) => (
  <div>
    <SectionLabel>{sectionLabel}</SectionLabel>
    <Text
      style={{
        color: BRAND_COLORS.secondary.lightGray,
        fontSize: 11,
        display: 'block',
        marginBottom: 8,
        fontFamily: 'monospace',
      }}
    >
      {fmtDateTime(periodStart)} — {fmtDateTime(periodEnd)}
    </Text>
    <div
      style={{
        background: BRAND_COLORS.primary.royalBlue,
        border: `1px solid ${BRAND_COLORS.secondary.steelBlue}`,
        borderRadius: 8,
        padding: '16px 20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 12,
        }}
      >
        <Text style={{ color: BRAND_COLORS.secondary.lightSage, fontSize: 12 }}>
          {headerPeriodLabel}
        </Text>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span
            style={{
              fontSize: 28,
              fontWeight: 700,
              color: statusColor,
              lineHeight: 1,
            }}
          >
            {headerValue}
          </span>
          <Tag
            style={{
              background: statusColor,
              border: 'none',
              color: '#fff',
              fontWeight: 600,
              fontSize: 11,
              textTransform: 'uppercase',
            }}
          >
            {statusLabel}
          </Tag>
        </div>
      </div>
      <MetricsDivider />
      {children}
    </div>
  </div>
);
